export default "__VITE_ASSET__b686595b__"